__turbopack_context__.v({
  "Icon": "CountrySelector-module__ZQ-JWG__Icon",
  "Item": "CountrySelector-module__ZQ-JWG__Item",
  "Popup": "CountrySelector-module__ZQ-JWG__Popup",
  "Positioner": "CountrySelector-module__ZQ-JWG__Positioner",
  "Trigger": "CountrySelector-module__ZQ-JWG__Trigger",
  "blok-big-title": "CountrySelector-module__ZQ-JWG__blok-big-title",
  "blok-subtitle": "CountrySelector-module__ZQ-JWG__blok-subtitle",
  "blok-title": "CountrySelector-module__ZQ-JWG__blok-title",
});
